import SerialConsole from './SerialConsole';

function App() {
  return (
    <SerialConsole />
  );
}

export default App;
